import React from "react";
import { useI18n } from "../../i18n";
import TicketLine from "./TicketLine";

const TicketLines = ({ lines, currency, onSetQuantity, onRemove }) => {
  const { t } = useI18n();

  if (lines.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-14 text-center px-6">
        <span className="text-5xl mb-3">🧺</span>
        <p className="text-slate-300 font-semibold">{t("pos.ticket.empty")}</p>
        <p className="text-slate-500 text-sm mt-1">
          {t("pos.ticket.emptyHint")}
        </p>
      </div>
    );
  }

  return (
    <div>
      {lines.map((line) => (
        <TicketLine
          key={line.product.id}
          line={line}
          currency={currency}
          onIncrement={() => onSetQuantity(line.product.id, line.quantity + 1)}
          onDecrement={() => onSetQuantity(line.product.id, line.quantity - 1)}
          onRemove={() => onRemove(line.product.id)}
        />
      ))}
    </div>
  );
};

export default TicketLines;
